const NETWORK_ERROR_PATTERN =
    /Network Error|ERR_NETWORK|ERR_INTERNET_DISCONNECTED|Failed to fetch|Load failed|Internet connection appears to be offline/i

export function isBrowserOffline() {
    return typeof navigator !== 'undefined' && navigator.onLine === false
}

export function isLikelyNetworkError(error) {
    if (!error) return false
    if (error.isOffline === true) return true
    if (isBrowserOffline()) return true

    const noHttpResponse = !error.response
    if (!noHttpResponse) return false

    const code = String(error?.code || '')
    const message = String(error?.message || '')
    return NETWORK_ERROR_PATTERN.test(`${code} ${message}`)
}

export function isLikelyNetworkEvent(event, hint) {
    if (isLikelyNetworkError(hint?.originalException)) {
        return true
    }

    const values = Array.isArray(event?.exception?.values) ? event.exception.values : []
    const messageParts = [
        event?.message,
        ...values.map((value) => value?.value),
        ...values.map((value) => value?.type),
    ]
    const combined = messageParts.filter(Boolean).join(' ')
    return NETWORK_ERROR_PATTERN.test(combined)
}
